import { serverlessRoutes } from "./constants";
import { postWithJwt } from "./requests";
import type { User } from "../interfaces/User";

// TODO: when we promote this to a real permission, replace the allowlist
// with a role check. Search for REPLACE_EXERCISE_ALLOWED_USER_IDS to find
// every spot that needs updating.
const REPLACE_EXERCISE_ALLOWED_USER_IDS = new Set<number>([13]);

const canReplaceExercises = (user: User | null | undefined): boolean =>
  !!user && REPLACE_EXERCISE_ALLOWED_USER_IDS.has(user.id);

interface ReplaceExerciseSuccessData {
  oldExerciseId: number;
  newExerciseId: number;
  movedReferences: {
    exerciseParent: number;
    statsParent: number;
    cantDoParent: number;
  };
  deletedOld: boolean;
  // True when the new exercise had a Cloudflare video and its youtubeId +
  // cloudflareVideoId were copied onto the re-pointed instance rows.
  mediaCopied: boolean;
  newExercise: any;
}

interface ReplaceExerciseResponse {
  data: ReplaceExerciseSuccessData | null;
  error: string | null;
}

const replaceExercise = async (
  oldExerciseId: number,
  newExerciseId: number
): Promise<ReplaceExerciseResponse> => {
  // Defense-in-depth: even though the menu item is hidden for non-allowed
  // users, refuse to fire the request from here too. The visible UI is the
  // gate, this helper is the gate, both must agree.
  const response = await postWithJwt(
    `${serverlessRoutes.EXERCISE}/${oldExerciseId}/replace`,
    { newExerciseId }
  );

  return response as ReplaceExerciseResponse;
};

export {
  REPLACE_EXERCISE_ALLOWED_USER_IDS,
  canReplaceExercises,
  replaceExercise,
};
export type { ReplaceExerciseResponse, ReplaceExerciseSuccessData };
